module.exports = __webpack_public_path__ + "static/aloopbread-2ba2d8e50ff8a2c4c06f68e161654e0c.png";